import { ReportType } from '@/modules/reports/ReportTypes';

/**
 * Matches the full-screen checklist fill flow route — `/my-reports/Checklist/new`
 * or `/my-reports/Checklist/new/<machineId>` — regardless of a leading
 * company/project scope segment. While this route is open the surrounding
 * chrome (machinist bottom nav, "Mis Partes" header row) is hidden so the
 * flow reads as a focused full-screen experience.
 */
export const isChecklistFillRoute = (pathname: string): boolean =>
  new RegExp(`/my-reports/${ReportType.Checklist}/new(/|$)`).test(pathname);
